import axios from 'axios'
const ins = axios.create() // 实例化一个axios
ins.interceptors.response.use(res => {
   console.log('拦截器')
   if (res.data.code !== 200) {
       return null
   }
   return res.data.data
})
export default ins